import React from 'react'
import clsx from 'clsx'
import { Flashy } from 'iconsax-react'
import { useTheme } from '@mui/material'
import Dropdown from '@SonarCX/components/atoms/Dropdown'
import TaskStatus from '@SonarCX/components/molecules/RenderOptions/TaskStatus'

const ChosenPriority = ({ selected, priorities }) => {
  if (!selected) {
    return <TaskStatus testId='priority' opt={{ name: 'Unassigned' }} />
  }

  return (
    <TaskStatus
      testId='priority'
      opt={priorities.find(({ id }) => id === selected) ?? {}}
    />
  )
}

const PrioritySection = ({
  classes,
  priorities,
  canEdit,
  handleChange,
  values
}) => {
  const theme = useTheme()

  const handleSelect = React.useCallback(
    id => {
      handleChange('priority')({ target: { value: id } })
    },
    [handleChange]
  )

  return (
    <div className={clsx(classes.center, classes.label, classes.mobile)}>
      <span className={clsx(classes.center, classes.label)}>
        <Flashy
          size={theme.size.base}
          variant='Bulk'
          color={theme.palette.primary.main}
        />
        PRIORITY
      </span>

      <Dropdown
        options={priorities.map(({ id }) => id)}
        renderOption={id => {
          const opt = priorities.find(s => s.id === id)

          if (opt) {
            return <TaskStatus key={id} opt={opt} testId='priority' />
          }
          return null
        }}
        selected={values.priority}
        onSelect={handleSelect}
        hideAdd
        colour
        disabled={!canEdit}
      >
        <ChosenPriority selected={values.priority} priorities={priorities} />
      </Dropdown>
    </div>
  )
}

export default PrioritySection
